// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ehcm","toggle":"styles_toggle__1JjZl","preview":"styles_preview__3I1xK"};